import { useTranslation } from "react-i18next";
import * as Yup from "yup";

export const YupClinic = () => {
  //page hook
  const { t } = useTranslation();
  return {
    clinicName: Yup.string().required(
      t("validation.required", {
        clinicName: t("page.clinicName"),
      })
    ),
    clinicJoinDate: Yup.string().required(
      t("validation.required", {
        clinicJoinDate: t("page.clinicJoinDate"),
      })
    ),
    phoneNumber: Yup.string().required(
      t("validation.required", {
        phoneNumber: t("page.phoneNumber"),
      })
    ),
    email: Yup.string()
      .email()
      .required(
        t("validation.required", {
          email: t("page.email"),
        })
      ),
    state: Yup.string().required(
      t("validation.required", {
        state: t("page.state"),
      })
    ),
    township: Yup.string().required(
      t("validation.required", {
        township: t("page.township"),
      })
    ),
    joinedProgram: Yup.array()
      .required(
        t("validation.required", {
          joinedProgram: t("page.joined_program"),
        })
      )
      .min(1),
    doctors: Yup.array()
      .required(
        t("validation.required", {
          doctors: t("page.providers"),
        })
      )
      .min(1),
    password: Yup.string()
      .required(
        t("validation.required", {
          password: t("page.password"),
        })
      )
      .min(8, t("validation.min_length", { min: "8" })),
    confirmPassword: Yup.string()
      .required(
        t("validation.required", {
          confirmPassword: t("page.confirm_password"),
        })
      )
      .min(8, t("validation.min_length", { min: "8" })),
  };
};

export const YupUpdateClinic = () => {
  //page hook
  const { t } = useTranslation();
  return {
    clinicName: Yup.string().required(
      t("validation.required", {
        clinicName: t("page.clinicName"),
      })
    ),
    clinicJoinDate: Yup.string().required(
      t("validation.required", {
        clinicJoinDate: t("page.clinicJoinDate"),
      })
    ),
    phoneNumber: Yup.string().required(
      t("validation.required", {
        phoneNumber: t("page.phoneNumber"),
      })
    ),
    email: Yup.string()
      .email()
      .required(
        t("validation.required", {
          email: t("page.email"),
        })
      ),
    state: Yup.string().required(
      t("validation.required", {
        state: t("page.state"),
      })
    ),
    township: Yup.string().required(
      t("validation.required", {
        township: t("page.township"),
      })
    ),
    joinedProgram: Yup.array()
      .required(
        t("validation.required", {
          joinedProgram: t("page.joined_program"),
        })
      )
      .min(1),
    doctors: Yup.array()
      .required(
        t("validation.required", {
          doctors: t("page.providers"),
        })
      )
      .min(1),
    password: Yup.string().min(8, t("validation.min_length", { min: "8" })),
    confirmPassword: Yup.string().min(8, t("validation.min_length", { min: "8" })),
  };
};
